export function storageAdapter(key) {
  return {
    get: () => window.localStorage.getItem(key),
    set: value => {
      window.localStorage.setItem(key, value);
    },
    remove: () => {
      window.localStorage.removeItem(key);
    }
  };
}

export function clear() {
  window.localStorage.clear();
}
